import { atom } from "recoil";

const dog = {
  name: '',
  image: ''
}
const comment = {
    authorUrl: "#",
    avatarUrl: "#avatarUrl",
    fullName: "Name",
    createdAt:  "",
    text: "" 
}

const forsaleitem = {
    name: "",
    url: "",
    description: "",
    parents: "",
    DOB: "",
    color: "",
    coat: "",
    personality: "",
    price: ""

}

//dog id
export const activeDogAtom = atom({
  key: "activeDog",
  default: dog
  });

export const dogsAtom = atom ({
  key: "dogs",
  default: []
});

export const imagesAtom = atom ({
  key: "images",
  default: [comment]
});

export const activeLogoAtom = atom({
  key: "activeLogo",
  default: ''
});

export const commentsAtom = atom({
  key: "comments",
  default: []
});

export const videosAtom = atom({
  key: "videos",
  default: []
  });

  export const forSaleAtom = atom({
    key: "forSale",
    default: [forsaleitem]
    });